import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Card,
  TableContainer,
  Paper,
  Link,
} from "@mui/material";

function OrdersList() {
  const navigate = useNavigate();
  const orders = [
    {
      id: 1,
      order_id: "107440964",
      subscriptionId: "154789/459",
      invoice: "154785698",
      product: "HRMS",
      subscription_plan: "Starter",
      purchasedOn: "20 Aug 2024",
      expiry: "19 Sep 2024",
      transaction_details: "154785996/Card",
      transaction_date: "20 Aug 2024",
    },
  ];

  const handleInvoiceClick = (invoice) => {
    navigate(`/invoices/${invoice}`);
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case "Active":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Active"
            color="success"
          />
        );
      case "Inactive":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Inactive"
            color="warning"
          />
        );
      case "Expired":
        return (
          <Chip variant="outlined" size="small" label="Expired" color="error" />
        );
      default:
        return <Chip variant="outlined" size="small" label={status} />;
    }
  };
  const getRenewalLabel = (renewal) => {
    switch (renewal) {
      case "auto":
        return (
          <Chip variant="outlined" size="small" label="Auto" color="success" />
        );
      case "manual":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Manual"
            color="warning"
          />
        );
      default:
        return <Chip variant="outlined" size="small" label={renewal} />;
    }
  };

  return (
    <Card elevation={4}>
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 650, textAlign: "center" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Order ID</TableCell>
              <TableCell align="center">Business Subscription ID</TableCell>
              <TableCell align="center">Invoice Number</TableCell>
              <TableCell align="center">Product Name</TableCell>
              <TableCell align="center">Subscription Plan</TableCell>
              <TableCell align="center">Subscribed/Renewed On</TableCell>
              <TableCell align="center">Renewal Type</TableCell>
              <TableCell align="center">Expiry</TableCell>
              <TableCell align="center">Transaction ID/Mode</TableCell>
              <TableCell align="center">Transaction Date</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow key={order.id}>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {index + 1}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.order_id}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.subscriptionId}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Link
                    component="button"
                    variant="body2"
                    onClick={() => handleInvoiceClick(order.invoice)}
                    sx={{ textDecoration: "none", color: "primary.main" }}
                  >
                    {order.invoice}
                  </Link>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.product}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.subscription_plan}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.purchasedOn}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {getRenewalLabel("manual")}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.expiry}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.transaction_details}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {order.transaction_date}
                </TableCell>
                <TableCell align="center">{getStatusLabel("Active")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default OrdersList;
